export { default } from './TinyLabel';
